export interface SimpleUpdateAcceptCollectionsRequest {
  collections: {
    id: number
    shelfType: string
    collectionType: string
    handlingType: string
    revision: number
  }[]
}

export function SimpleUpdateAcceptCollectionsRequestToJSON(
  value: SimpleUpdateAcceptCollectionsRequest
): any {
  return {
    collections:
      value.collections.length > 0
        ? value.collections.map(collection => ({
            id: collection.id !== 0 ? collection.id : undefined,
            shelf_type:
              collection.shelfType !== '' ? collection.shelfType : undefined,
            collection_type:
              collection.collectionType !== ''
                ? collection.collectionType
                : undefined,
            handling_type:
              collection.handlingType !== ''
                ? collection.handlingType
                : undefined,
            revision:
              collection.revision !== 0 ? collection.revision : undefined
          }))
        : undefined
  }
}
